export const GridViewInstructionsLink = 'https://porsche.sharepoint.com/sites/GETEXPorscheintern/SitePages/Rasteransicht-VKO.aspx';
